import { render, staticRenderFns } from "./AnimatedBannerSingle.vue?vue&type=template&id=8bbe9404&"
import script from "./AnimatedBannerSingle.vue?vue&type=script&lang=js&"
export * from "./AnimatedBannerSingle.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedBannerSingle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports